/* eslint-disable react-native/no-inline-styles */
/**
 * @author Granite Bagas
 */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import PropTypes from 'prop-types';

import ModalTopRounded from '@components/modal/ModalTopRounded';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import ModalUpload from '@components/modal/ModalUpload';

import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import importTemplateCreate from '@/assets/csv/template-import-create-rpt';
import importTemplateActive from '@/assets/csv/template-import-active-rpt';
import { MsOrder } from '@api/ms-order';

const propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  handleAdd: PropTypes.func,
  year: PropTypes.string,
};

const VALID_HEADER_CREATE = ['customer_code', 'sku', 'year'];

const VALID_HEADER_ACTIVE = ['customer_code', 'sku', 'is_active'];

const ModalCreateRequestProductListing = (props) => {
  const dispatch = useDispatch();

  const [showCsvOptions, setShowCsvOptions] = useState(false);
  const [csvOption, setCsvOption] = useState();

  const showImportModalRequestProductListing = useSelector(
    (state) => state.modal.showImportModalRequestProductListing,
  );

  const handleImport = async (url) => {
    const failedProcess = () => {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(
        showPopup({
          name: 'showImportModalRequestProductListing',
          value: false,
        }),
      );
    };

    const selectedCsvOption = JSON.parse(JSON.stringify(csvOption));
    try {
      dispatch(
        showPopup({
          name: 'showImportModalRequestProductListing',
          value: false,
        }),
      );
      let response = null;
      const payload = {
        url,
        year: props.year,
      };
      if (selectedCsvOption == 'create') {
        response = await MsOrder.importCreateProductListing(payload);
      } else {
        response = await MsOrder.importActiveProductListing(payload);
      }
      if (response.status == 200) {
        Toast.show({
          text1: `${
            selectedCsvOption == 'create'
              ? 'Import Create RPT'
              : 'Import Active RPT'
          } In Progress`,
          type: 'success',
        });
      } else {
        failedProcess();
      }
    } catch (error) {
      console.log(error);
      failedProcess();
    }
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleAddManually = () => {
    props.handleAdd();
  };

  const handleShowCsvOptions = () => {
    handleClose();
    setCsvOption();
    setShowCsvOptions(true);
  };

  const handleCloseCsvOption = () => {
    setCsvOption();
    setShowCsvOptions(false);
  };

  const handleSelectCsvOption = (opt) => {
    handleClose();
    setCsvOption(opt);
    setShowCsvOptions(false);
    dispatch(
      showPopup({
        name: 'showImportModalRequestProductListing',
        value: true,
      }),
    );
  };

  return (
    <View>
      <ModalTopRounded
        title="Add Product Tester"
        visible={props.show}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={handleClose}>
        <View style={styles.userCreate}>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleAddManually}>
            <Image
              style={{ width: 43, height: 43 }}
              width={43}
              height={43}
              source={require('@assets/img/icons/add-manually.png')}
            />
            <SociollaText style={styles.itemText}>Add Manually</SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={handleShowCsvOptions}>
            <Image
              style={{ width: 35, height: 43 }}
              width={35}
              height={43}
              source={require('@assets/img/icons/import-csv.svg')}
            />
            <SociollaText style={styles.itemText}>Import CSV</SociollaText>
          </TouchableOpacity>
        </View>
      </ModalTopRounded>

      <ModalTopRounded
        title="Import CSV"
        visible={showCsvOptions}
        maxWidth={isWeb && !isMobileWeb ? 500 : '100%'}
        onClose={handleCloseCsvOption}>
        <View
          style={[
            styles.userCreate,
            {
              ...(isWeb
                ? {}
                : {
                    flexDirection: 'column',
                    gap: 10,
                  }),
            },
          ]}>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={() => handleSelectCsvOption('create')}>
            <Image
              style={{ width: 43, height: 43 }}
              width={43}
              height={43}
              source={require('@assets/img/icons/import-csv.svg')}
            />
            <SociollaText style={styles.itemText}>
              Import Create Product Tester
            </SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.itemOption}
            onPress={() => handleSelectCsvOption('active')}>
            <Image
              style={{ width: 35, height: 43 }}
              width={35}
              height={43}
              source={require('@assets/img/icons/import-csv.svg')}
            />
            <SociollaText style={styles.itemText}>
              Import Active/Inactive Product
            </SociollaText>
          </TouchableOpacity>
        </View>
      </ModalTopRounded>

      {showImportModalRequestProductListing ? (
        <ModalUpload
          show={showImportModalRequestProductListing}
          onClose={() =>
            dispatch(
              showPopup({
                name: 'showImportModalRequestProductListing',
                value: false,
              }),
            )
          }
          templateUrl={
            csvOption == 'create' ? importTemplateCreate : importTemplateActive
          }
          onUpload={handleImport}
          autoUploadS3={true}
          name={`${
            csvOption == 'create' ? 'import_create_rpt' : 'import_active_rpt'
          }`}
          validHeader={
            csvOption == 'create' ? VALID_HEADER_CREATE : VALID_HEADER_ACTIVE
          }
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  userCreate: {
    width: '100%',
    paddingHorizontal: isWeb ? 25 : 15,
    paddingTop: isWeb ? 25 : 15,
    paddingBottom: isWeb ? 40 : 15,
    justifyContent: 'center',
    flexDirection: 'row',
  },
  itemOption: {
    padding: 15,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    marginHorizontal: isWeb ? 15 : 10,
  },
  itemText: {
    fontSize: 14,
    marginTop: 15,
  },
});

ModalCreateRequestProductListing.propTypes = propTypes;

export default ModalCreateRequestProductListing;
